// Podněty uživatelů administrátorovi (rozhodnutí uživatele 2026-11-01) —
// část načtená hned (Moje úkoly, menu profilu). Obrazovky jsou ve
// views/feedback.js (načítá se až při otevření).
import { myRole, state } from './state.js';

var FEEDBACK_TYPES = [['data', 'Chyba v údajích'], ['app', 'Chyba v aplikaci'], ['idea', 'Návrh na zlepšení']];
var FEEDBACK_TYPE_LABELS = {};
FEEDBACK_TYPES.forEach(function(t){ FEEDBACK_TYPE_LABELS[t[0]] = t[1]; });

// Vyřízené podněty, které autor už viděl (Moje podněty) — jen v zařízení.
function seenKey(){ return 'bozp-feedback-seen-' + (state.myId || ''); }
function feedbackSeenSet(){
  try{ return new Set(JSON.parse(localStorage.getItem(seenKey()) || '[]')); }catch(e){ return new Set(); }
}
function markFeedbackSeen(ids){
  if(!ids.length) return false;
  var s = feedbackSeenSet(), before = s.size;
  ids.forEach(function(id){ s.add(id); });
  if(s.size===before) return false;
  try{ localStorage.setItem(seenKey(), JSON.stringify(Array.from(s))); }catch(e){}
  return true;
}
function myFeedbackList(){
  var out = [];
  state.feedback.forEach(function(f, id){ if(f.authorId && f.authorId===state.myId) out.push([id, f]); });
  return out.sort(function(a, b){ return String(b[1].createdAt||'').localeCompare(String(a[1].createdAt||'')); });
}
// Moje úkoly: Administrátor = nové podněty, autor = vyřízené, které ještě neviděl.
function feedbackTaskCounts(){
  var out = {newForAdmin:0, resolvedUnseen:0};
  if(!state.myId || !state.ready.feedback) return out;
  var admin = myRole()==='administrator', seen = null;
  state.feedback.forEach(function(f, id){
    var st = f.status || 'new';
    if(admin && st==='new') out.newForAdmin++;
    if(f.authorId===state.myId && st!=='new'){
      seen = seen || feedbackSeenSet();
      if(!seen.has(id)) out.resolvedUnseen++;
    }
  });
  return out;
}

// „Nahlásit chybu“ z menu profilu: kontext (kde uživatel byl) se zachytí
// hned, ještě před přechodem na formulář.
window.App = window.App || {};
App.openFeedbackForm = function(){
  var meta = document.querySelector('meta[name="app-build"]');
  var co = state.currentCompanyId && state.companies.get(state.currentCompanyId);
  state.fbDraft = {type:'data', text:'', attachments:[], context:{
    path: location.pathname, view: state.view,
    companyId: state.currentCompanyId || '', companyName: (co && co.name) || '',
    build: meta ? meta.getAttribute('content') : '', ua: navigator.userAgent
  }};
  App.setView('feedbackNew');
};

export {
  FEEDBACK_TYPES,
  FEEDBACK_TYPE_LABELS,
  feedbackSeenSet,
  feedbackTaskCounts,
  markFeedbackSeen,
  myFeedbackList
};
